import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchJson } from '../../../../helpers/fetch.js';
import { useSelector } from 'react-redux';

import {
  monitoring_dashboard_payments_data_path,
} from '~/routes';
import ChartContent from '../base/ChartContent.jsx';

export const DATASETS = ["planned", "paid"];
const TOOLTIP_WORD_LENGTH = 25;

function PaymentsWidget({widgetId, widgetRef}) {
  const projectId = useSelector(state => state.dashboard.projectId);
  const { call_id, start_date, end_date, legend_text_color, datasets } = useSelector(state => state.dashboard.widgets[widgetId].settings);

  const { data } = useQuery({
    queryKey: ['paymentsWidgetPaymentsData', projectId, call_id, start_date, end_date],
    queryFn: async () => fetchJson(monitoring_dashboard_payments_data_path({ project_id: projectId, call_id, start_date, end_date })),
    enabled: !!projectId,
  });

  const tooltipTextFormatter = (text) => {
    const stringList = []
    while (true){
      let end = text.indexOf(" ", TOOLTIP_WORD_LENGTH);
      end = end >= 0 ? end : text.length;
      let substr = text.substring(0,end);
      stringList.push(substr)
      if (end >= text.length) {
        break;
      }
      text = text.substring(end+1);
    }
    return stringList
  }

  const getChartOptions = ({ start_date, end_date, interval }) => {
    return {
      maintainAspectRatio: false,
      devicePixelRatio: 2,
      tooltips: {
        callbacks: {
          title: (tips, data) => {
            const { datasetIndex, index } = tips[0];
            return tooltipTextFormatter(data.datasets[datasetIndex].data[index].label);
          },
          label: function(tooltipItem, data) {
            return StringHelper.addNumberDelimiter(tooltipItem.yLabel, {delimiter: ','});
          }
        },
        legend: {
          labels: {
            color: legend_text_color
          }
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            callback: function(label) {
              return StringHelper.addNumberDelimiter(label, { delimiter: ',' });
            }
          }
        },
        x: {
          type: 'time',
          time: {
            min: start_date,
            max: end_date,
            minUnit: 'day',
            unit: interval,
          },
          ticks: {
            autoSkip: true,
            autoSkipPadding: 15,
          }
        }
      }
    };
  }

  const formatData = () => {
    let newData = {};

    newData.datasets = DATASETS.map((ds, i) => ({
      label: datasets[i].name_item,
      data: (data?.[ds] || []).map((d) => ({
        x: dayjs(d.payment_date).format("YYYY-MM-DD"),
        y: d.payments,
        label: d.formatted_payment_date,
      })),
      fill: false,
      backgroundColor: datasets[i].background_color,
      borderColor: datasets[i].background_color,
      pointRadius: 4,
      lineTension: 0.2,
    }));

    return newData;
  };

  return (
      <ChartContent
          chart_type='line'
          chart_container_classes={['h-100']}
          {...{formatData, getChartOptions, data, widgetId, widgetRef}}
      />
  )
};

export default PaymentsWidget;